var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.0003,
    cy: 45.2335,
    rx: 45.639,
    ry: 45.0778,
    fill: "#3C99FC",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.011 35.427C39.4889 27.1436 53.2344 27.1436 61.7123 35.427L62.7327 36.4239C63.1566 36.8381 63.1566 37.5096 62.7327 37.9237L59.2423 41.334C59.0303 41.5411 58.6867 41.5411 58.4748 41.334L57.0707 39.9621C51.1562 34.1834 41.5671 34.1834 35.6526 39.9621L34.1489 41.4313C33.937 41.6384 33.5934 41.6384 33.3814 41.4313L29.8911 38.021C29.4672 37.6069 29.4672 36.9354 29.8911 36.5212L31.011 35.427ZM68.9307 42.4798L72.0371 45.5149C72.461 45.9291 72.461 46.6006 72.0371 47.0147L58.0301 60.7005C57.6062 61.1147 56.9189 61.1147 56.495 60.7006C56.495 60.7005 56.495 60.7005 56.495 60.7005L46.5536 50.9873C46.4476 50.8838 46.2758 50.8838 46.1698 50.9873C46.1698 50.9873 46.1698 50.9873 46.1698 50.9873L36.2286 60.7005C35.8048 61.1147 35.1175 61.1147 34.6936 60.7006C34.6936 60.7006 34.6936 60.7006 34.6936 60.7005L20.6861 47.0145C20.2622 46.6004 20.2622 45.9289 20.6861 45.5147L23.7925 42.4796C24.2164 42.0654 24.9037 42.0654 25.3276 42.4796L35.2691 52.1929C35.3751 52.2965 35.5469 52.2965 35.6529 52.1929C35.6529 52.1929 35.6529 52.1929 35.6529 52.1929L45.5939 42.4796C46.0178 42.0654 46.7051 42.0654 47.129 42.4795C47.129 42.4796 47.129 42.4796 47.129 42.4796L57.0705 52.1929C57.1765 52.2965 57.3483 52.2965 57.4543 52.1929L67.3957 42.4798C67.8195 42.0656 68.5068 42.0656 68.9307 42.4798Z",
    fill: "#3C99FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 32,
    fill: "white",
    transform: "translate(20.3613 29.1556)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.b99025bbc8cccffa59789f81799055ea.svg";
export { ForwardRef as ReactComponent };